import { Controller } from '@hotwired/stimulus'
import { throttle, isScrollDisabled } from '../utils/global'

const SCROLL_DIRECTION_DELTA = 4

// Получаем направление скролла из атрибутов или классов на body
export function getBodyScrollDirection() {
  const { body } = document

  if (body.dataset.scrollDirection === 'up') return 'up'
  if (body.dataset.scrollDirection === 'down') return 'down'

  return null
}

// Наблюдаем за изменениями в классе и data-атрибутах body, чтобы определить направление скролла
export function observeBodyScrollDirection(callback) {
  const body = document.body
  let previous = getBodyScrollDirection()

  const observer = new MutationObserver(() => {
    const next = getBodyScrollDirection()
    if (next === previous) return

    previous = next
    callback(next)
  })

  observer.observe(body, {
    attributes: true,
    attributeFilter: ['class', 'data-scroll-direction']
  })

  return () => observer.disconnect()
}

// Контроллер для определения направления скролла
export default class ScrollDirectionController extends Controller {
  #lastDirection = null
  throttledHandleScroll = null

  connect() {
    this.#lastDirection = window.scrollY
    this.#syncScrollPosition(window.scrollY)

    this.throttledHandleScroll = throttle(this.handleScroll.bind(this), 100)

    window.addEventListener('scroll', this.throttledHandleScroll, {
      passive: true
    })
    this.handleScroll()
  }

  disconnect() {
    window.removeEventListener('scroll', this.throttledHandleScroll)
  }

  handleScroll() {
    const currentScrollY = Math.max(0, window.scrollY) // Игнорируем отрицательные значения (bounce эффект (iOS) scrollY может быть отрицательным)
    const delta = currentScrollY - this.#lastDirection
    const direction =
      Math.abs(delta) >= SCROLL_DIRECTION_DELTA ? Math.sign(delta) : 0

    // Обновляем направление только если есть реальное изменение
    if (direction !== 0) {
      this.#setDirection(direction)
    }

    this.#lastDirection = currentScrollY
    this.#syncScrollPosition(currentScrollY)

    // Сбрасываем классы только если находимся в самом верху И скроллим вверх
    if (currentScrollY === 0 && direction <= 0) {
      this.#clearDirection()
    }
  }

  #setDirection(direction) {
    const scrollDirection = getBodyScrollDirection()
    const hasScrollDirection =
      scrollDirection === 'down' || scrollDirection === 'up'

    if (
      !isScrollDisabled() &&
      direction !== 0 &&
      (!hasScrollDirection ||
        direction !== (scrollDirection === 'down' ? 1 : -1))
    ) {
      document.body.dataset.scrollDirection = direction > 0 ? 'down' : 'up'
    }
  }

  #clearDirection() {
    delete document.body.dataset.scrollDirection
  }

  #syncScrollPosition(currentScrollY) {
    document.body.dataset.scrollPosition =
      currentScrollY === 0 ? 'top' : 'scrolled'
  }
}
